import { render, staticRenderFns } from "./StaffCompany.vue?vue&type=template&id=0ca89e86&scoped=true"
import script from "./StaffCompany.vue?vue&type=script&lang=js"
export * from "./StaffCompany.vue?vue&type=script&lang=js"
import style0 from "./StaffCompany.vue?vue&type=style&index=0&id=0ca89e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca89e86",
  null
  
)

export default component.exports